<div class="border-div" style="min-height:350px;" *ngIf="showItems">
    <div class="floatinghead floatinghead-xs clearfix cf">
        <h2 class="mainhead"><span class="text"> Place Offer Made Easier</span></h2>
        <button class="btn btn-success pull-right btn-lg margin-bottom-15" (click)="showPlaceOffer($event)" *ngIf="!showPlaceOfferScreen">Place Offer</button>
      
    </div>  
    
    <app-portfolio-property-list [propertyGuid]="propertyGuid" [property]="property" (save)="seletedProperties($event)" (show)="showPlaceOffer($event)" [selectAllStatus]="true"></app-portfolio-property-list>
</div>

<div class="" style="min-height:350px;" *ngIf="showPlaceOfferScreen">
    <place-offer [inputPropertyGuid]="propertyGuid" [inputPropertyId]="property.Id" (showPortfolioData)="offerPlaced($event)" [isPortfolio]="true" [IsFromPropertyView]="true" [propertyList]="propertyList" [askingPrice]="askingPrice"></place-offer>
</div>
